import {NgModule} from '@angular/core';
import {FangAutocompleteDropdownComponent} from "./fang-autocomplete-dropdown.component";
import {FangAutocompleteInputDirective} from "./directives/fang-autocomplete-input.directive";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@NgModule({
	imports: [
		CommonModule,
		FormsModule
	],
	exports: [
		FangAutocompleteInputDirective
	],
	declarations: [
		FangAutocompleteDropdownComponent,
		FangAutocompleteInputDirective
	],
	providers: [],
	entryComponents: [FangAutocompleteDropdownComponent]
})
export class FangAutocompleteModule {
}
